const Button = ({
	children,
	onClick,
	variant = 'primary',
	size = 'md',
	className = '',
	disabled = false,
	type = 'button',
	fullWidth = false,
}) => {
	const baseClasses = 'btn';
	const variantClasses = `btn-${variant}`;
	const sizeClasses = size === 'lg' ? 'btn-lg' : '';
	const widthClasses = fullWidth ? 'w-full' : '';
	const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';

	return (
		<button
			type={type}
			className={`${baseClasses} ${variantClasses} ${sizeClasses} ${widthClasses} ${disabledClasses} ${className}`}
			onClick={onClick}
			disabled={disabled}
		>
			{children}
		</button>
	);
};

export default Button;
